import { lighten } from "@mui/material";

export const getBackgroundColor = (color, selected) => (selected ? lighten(color, 0.2) : lighten(color, 0.4));
export const getHoverColor = (color, selected) => (selected ? lighten(color, 0.1) : lighten(color, 0.3));
